/*import "../confetti.js";*/
import * as SDCCore from "scandit-web-datacapture-core";
import * as SDCBarcode from "scandit-web-datacapture-barcode";

import confetti from "../../confetti.js";


$.widget("custom.ticketcheckerpage",
    {
        options: {
            extra_chansen: true,
            disable_scanner: false,
            disable_rattalotten: false,
            disable_rattalottenmobile: false,
            api_key: "",
            cdn_url: ""
        },
        _create: function () {
            var $widget = this,
                $this = $widget.element;

            var availableTicketAmount;
            var suggestionProductName;
            var suggestionGameStart;
            var suggestionArticleNumber;
            var suggestionProductNumber;
            var suggestionArticleKey;
            var suggestionArticlePrice;

            var sellerAccountType;
            var sellerAccountName;
            var sellerAccountActive;

            var articleNumber;
            var productArticleMap;
            var mappedProductNumber;

            var winIndex = 0;
            var globalWinningsList = "";

            var bingoBonus;

            var lastScannedArticleNumber = "";
            var lastScannedProductNumber = "";

            var ticketStoredInSession;

            var manuallyTicketStoredInSession;

            let bingoBonusAmount = null;

            var userCommissions = null;
            var commissionList = [];

            var scanningEnabled = false;

            var barcodeCapture;

            const BingolottoProductNumber = "0010";

            var manuallyCheckedTicketMultiplier;
            var manuallyCheckedTicketAmount;

            $('.ticketCashInStep1').show();

            $('#stepScannerGuide').on('click', function () {
                if (!$widget.options.disable_scanner) {
                    resetPanels();
                    showStep2();
                    Utils.PushGoogleTag('Click_check_ticket_and_redeem');
                }
            })

            $('#StepManualTicketCheck').on('click', function () {
                if (!($widget.options.disable_rattalotten || $widget.options.disable_rattalottenmobile)) {
                    resetPanels();
                    showManualStep();
                    Utils.PushGoogleTag('Click_check_ticket_manually');
                }
            })

            $('#manualCheckLink').on('click', function () {
                resetPanels();
                showManualStep();
                Utils.PushGoogleTag('Click_check_ticket_manually');
            })
            
            $('#scanTicketButton').on('click', function () {
                resetPanels();
                showStep3();
                Utils.PushGoogleTag('Click_start_scanning_ticket');
            })

            var scrollToManualList = function () {
                if ($.browser.mobile) {
                    const id = 'manualTicketList';
                    const yOffset = -150;
                    const element = document.getElementById(id);
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }

            var resetPanels = function () {
                $('.ticketCashInStep1').hide();
                $('.ticketCashInStep2').hide();
                $('.ticketCashInStep3').hide();
                $('.manualTicketCheck').hide();
            }

            var showStep2 = function (showList = false) {
                if ((ticketStoredInSession && ticketStoredInSession.length) || showList) {
                    getWallet(); //TEST
                    $('.scannedTicketsDiv').show();
                    $('.ticketCashInStep2').show();
                } else {
                    $('.ticketCashInStep2').show();
                }
            }

            var showStep3 = function () {
                $('.ticketCashInStep3').show();
            }

            var showManualStep = function () {

                if (manuallyTicketStoredInSession && manuallyTicketStoredInSession.length) {
                    $('.purple-block').removeClass('col-sm-5').addClass('.col-sm-12');
                    $('.purple-block-content').addClass('col-sm-6');
                    $('.scanTicketInformation').addClass('col-lg-12');
                    $('.manualTicketInformation').fadeIn().addClass('col-lg-5 col-xs-12');
                    $('.checkedTicketsList').show();
                }

                $('.manualTicketCheck').show();
            }

            var createIconUrl = function (productNumber, articleNumber) {
                return window.Urls.CdnRoot + "product-assets/" + productNumber + "_" + articleNumber + "_icon.png";
            }

            var addScannedTicketsToList = function (icon, productNumber, productName, win, isHighWin) {

                var multiplier = 1;

                if (win && win[0].Multiplier) {
                    multiplier = win[0].Multiplier;
                }

                var multiplierText = "";
                if (multiplier > 1) {
                    multiplierText = "X" + multiplier;
                }

                var htmlObject = `<div class="checkedTicketCol">
                                    <div class="row checkedTicketRow">
                                    <div class="col-xs-2 image-col">
                                        <img src="`+ icon + `" alt="` + productName + `">
                                    </div>
                                    <div class="col-xs-6 info-col">
                                        <label class="ticketNameLabel">` + productName + " " + multiplierText + `</label>`;

                if (!win) {
                    htmlObject = htmlObject + `<span>Ingen vinst</span>`;
                    htmlObject = htmlObject + `</div><div class="winningActionDiv col-xs-4">`;
                    if ($widget.options.extra_chansen && productNumber == BingolottoProductNumber) {
                        htmlObject = htmlObject + `<span>Registrerad för<br><b>Extrachansen</b></span>`;
                    }
                    htmlObject = htmlObject + `</div>`;
                }
                else {
                    
                    if (isHighWin == true) {
                        htmlObject = htmlObject + `<span class="bold">Högvinst!</span><br><span>Skicka in lotten</span></div>`;

                        htmlObject = htmlObject + `<div class="winningActionDiv col-xs-4"><a href="/om-bingolotto/fragor-och-svar/faq-vinster-och-vinstchanser/" class="btn btn btn-primary" target="_blank">Mer info</a></div></div>`;
                    } else {
                        htmlObject = htmlObject + `<span>Vinst!</span></div>`;
                        if (mappedProductNumber == BingolottoProductNumber) {
                            htmlObject = htmlObject + `<div class="winningActionDiv pad-t-half col-xs-4"><a href="/kop-bingolott/" class="btn btn btn-primary" target="_self">Köp ny lott</a></div></div>`;
                        } else {
                            htmlObject = htmlObject + `<div class="winningActionDiv pad-t-half col-xs-4"><a href="/onlinespel/skraplotter/" class="btn btn btn-primary" target="_self">Köp ny lott</a></div></div>`;
                        }
                    }
                }

                //Row listin all winnings
                if (win) {
                    htmlObject = htmlObject + `<div class="row">
                                                   <div class="col-xs-10 col-xs-offset-2">`;

                    for (var i = 0; i < win.length; i++) {
                        if (win[i].IsCashWin == true) {
                            htmlObject = htmlObject + `<span class="bold">` + win[i].Amount * win[i].Multiplier + ` kronor</span>`;
                        }
                        if (win[i].IsTicketWin == true) {
                            htmlObject = htmlObject + `<span class="bold">` + win[i].Description + " " + win[i].Amount * win[i].Multiplier + ` kronor</span>`;
                        }

                        if (i + 1 != win.length) {
                            htmlObject = htmlObject + "<br>";
                        }

                    }
                    htmlObject = htmlObject + `</div></div>`;
                }

                htmlObject = htmlObject + `</div>`;

                $('.previousScannedTickets').prepend(htmlObject);
            };

            var addManualTicketsToList = function (win, ticketPid, multiplier) {

                //You can only correct BingoLotto manually
                var icon = createIconUrl(BingolottoProductNumber, "2006");

                var multiplierText = "";
                if (multiplier > 1) {
                    multiplierText = "X" + multiplier;
                }

                var htmlObject = `<div class="checkedTicketCol">
                                    <div class="row checkedTicketRow">
                                    <div class="col-xs-2 image-col">
                                        <img src="`+ icon + `" alt="Bingolott">
                                    </div>
                                    <div class="col-xs-5 info-col">
                                        <label class="ticketNameLabel">Bingolott ` + multiplierText + `</label>
                                        <span>` + ticketPid + `</span><br>`;

                if (!win) {
                    htmlObject = htmlObject + `<span>Ingen vinst</span>`;
                    htmlObject = htmlObject + `</div><div class="winningActionDiv col-xs-5">`;
                }
                else {
                    htmlObject = htmlObject + `<span>Vinst!</span><br>`;
                    if ($.browser.mobile) {
                        htmlObject = htmlObject + `</div><div class="winningActionDiv col-xs-5"> <a class="cashInWinButton btn btn-primary">TA UT DIREKT</a>`;
                    } else {
                        htmlObject = htmlObject + `</div><div class="winningActionDiv col-xs-5">`;
                    }
                }
                htmlObject = htmlObject + `</div></div>`;

                if (win) {
                    htmlObject = htmlObject + `<div class="row">
                                                   <div class="col-xs-10 col-xs-offset-2">`;

                    for (var i = 0; i < win.length; i++) {


                        if (win[i].DisplayWinningValue == true) {
                            htmlObject = htmlObject + `<span class="bold">` + win[i].Description + " " + win[i].Amount + ` kr` + `</span>`;
                        }
                        if (win[i].DisplayWinningValue != true) {
                            htmlObject = htmlObject + `<span class="bold">` + win[i].Description + `</span>`;
                        }

                        if (i + 1 != win.length) {
                            htmlObject = htmlObject + "<br>";
                        }
                    }

                    htmlObject = htmlObject + `</div></div>`;

                }
                
                htmlObject = htmlObject + `</div>`;

                $('.manuallyCheckedTickets').prepend(htmlObject);

                if ($.browser.mobile) {

                    setTimeout(function () {
                        $('.cashInWinButton').click(function () {
                            resetPanels();
                            showStep2();
                            Utils.PushGoogleTag('Click_check_ticket_and_redeem');
                        })
                    }, 100);
                }
            };

            var manualCheckTicket = function () {
                $('#winList').empty();
                

                var inputValue = $('#manualInputField').val();

                if (!inputValue) return;

                var serieNumber = inputValue.substring(0, 4);
                var ticketNumber = inputValue.substring(4, 9);

                $.ajax({
                    url: '/Ticket/CheckTicket',
                    type: "POST",
                    dataType: "json",
                    data: {
                        Series: serieNumber,
                        Number: ticketNumber
                    },
                    success: function (response) {

                        //TEST
                        console.log(response);
                        //End of test

                        if (response.Error) {
                            if (response.ErrorMessage != null) {
                                //Visa errormessage för användare.
                                setTimeout(function () {
                                    $('#scanTicketLoading-overlay').hide();
                                    ModalHandler.InformationModal("ETT FEL INTRÄFFADE", "", response.ErrorMessage, function () { });
                                }, 3000);
                            }
                            else {
                                //Visa tekniskt fel för användare
                                setTimeout(function () {
                                    $('#scanTicketLoading-overlay').hide();
                                    ModalHandler.InformationModal("ETT FEL INTRÄFFADE", "", "Vi har tekniska problem just nu. Försök igen om en stund eller kontakta kundtjänst på 0771-440 440 så hjälper vi dig.", function () { });
                                }, 3000);
                            }
                        }
                        
                        if (response.Blank) {
                            setTimeout(function () {
                                $('#scanTicketLoading-overlay').hide();
                                ModalHandler.InformationModal("INGEN VINST", "fas fa-solid fa-heart fa-4x redIcon", "Det blev tyvärr ingen vinst den här gången. *new_line**new_line*Men du vet väl att allt överskott från våra lotter går direkt till *bold_start*svenskt föreningsliv*bold_end*?*new_line**new_line* Tack för att du är med och stöttar våra lag och föreningar!", function () { });
                   /*             addManualTicketsToList(null, response.Series + " " + response.Number, 1); //In case of blank we cant know the multiplier*/
                            }, 3000);
                            $('.purple-block').removeClass('col-sm-5').addClass('.col-sm-12');
                            $('.purple-block-content').addClass('col-sm-6');
                            $('.scanTicketInformation').addClass('col-lg-12');
                            $('.manualTicketInformation').fadeIn().addClass('col-lg-5 col-xs-12');
                            $('.checkedTicketsList').show();
                        }

                        if (response.Win) {

                            //OM HÖGVINST VISA INFORMATIONMODAL
                            var ticketResults = response.Winnings;

                            $.each(ticketResults, function (i, item) {
                                var winDescription = ticketResults[i].Description;
                                var winValue = ticketResults[i].Value;
                                var displayWinValue = ticketResults[i].DisplayWinningValue;

                                manuallyCheckedTicketMultiplier = ticketResults[i].Multiplier;
                                manuallyCheckedTicketAmount = ticketResults[i].Amount;

                                if (displayWinValue) {
                                    $('#winList').append('<div class="winningsDisplayer">' + winDescription + " " + manuallyCheckedTicketAmount + ' kr' + '</div>');
                                } else if (displayWinValue == false) {
                                    $('#winList').append('<div class="winningsDisplayer">' + winDescription + '</div>');
                                }
                            });

                            //Visa modal - onödigt vid vinst på rätta lotten
                            
                            setTimeout(function () {
                                $('.ticketCheckerWinModal').fadeOut();
                            }, 7000)
                            
                            //Visa Vinstsplash
                            setTimeout(function () {
                                $('#scanTicketLoading-overlay').fadeOut();
                                $('.ticketCheckerWinModal').show();
                                confettiCannon();
/*                                addManualTicketsToList(response.Winnings, response.Series + " " + response.Number, manuallyCheckedTicketMultiplier);*/
                                $('.purple-block').removeClass('col-sm-5').addClass('.col-sm-12');
                                $('.purple-block-content').addClass('col-sm-6');
                                $('.scanTicketInformation').addClass('col-lg-12');
                                $('.manualTicketInformation').fadeIn().addClass('col-lg-5 col-xs-12');
                                $('.checkedTicketsList').fadeIn();
                                scrollToManualList();
                            }, 3000);
                            
                        }

                        if (response.Win == true || response.Blank == true) {

                            var alreadyInList = false;
                            $.each(manuallyTicketStoredInSession, function (index, value) {
                                if (response.Series + response.Number === value.Series + value.Number) {
                                    alreadyInList = true;
                                }
                            });

                            if (alreadyInList) {
                                return;
                            }

                            if (response.Win) {
                                addManualTicketsToList(response.Winnings, response.Series + " " + response.Number, manuallyCheckedTicketMultiplier);
                            }
                            if (response.Blank) {
                                addManualTicketsToList(null, response.Series + " " + response.Number, 1); //In case of blank we cant know the multiplier
                            }

                            manuallyTicketStoredInSession.push(response);
                            window.fsStorage.set('redeem.manual.ticket_list', manuallyTicketStoredInSession, 60 * 30);
                            scrollToManualList();
                        }

                    },
                    error: function (response) {
                        //Fix error codes

                        ModalHandler.InformationModal("ETT FEL INTRÄFFADE", "", "Vi har tekniska problem just nu. Försök igen om en stund eller kontakta kundtjänst på 0771-440 440 så hjälper vi dig.", function () { });
                    }
                });
            }

            /*******************Manual ticket checker page********************/
            $('#manualCheckTicketButton').on('click', function () {

                var inputValue = $('#manualInputField').val();

                var alreadyInList = false;
                $.each(manuallyTicketStoredInSession, function (index, value) {
                    if (inputValue === value.Series + " " + value.Number || inputValue === value.Series + value.Number) {
                        alreadyInList = true;
                        return;
                    }
                });
                if (alreadyInList) {
                    ModalHandler.InformationModal("Redan rättad", "", "Lotten med det här serie- och lottnummret har redan blivit rättad. Du kan se den under Mina rättade lotter.", function () {
                    });
                }

                if (!alreadyInList) {
                    $('#scanTicketLoading-overlay').show();
                    manualCheckTicket();
                    Utils.PushGoogleTag('Click_check_ticket_button');
                    $('#manualInputField').val('');
                }

            });

            $('.ticketCheckerWinModal').on('click', function () {
                $('.ticketCheckerWinModal').clearQueue().finish();
                $('.ticketCheckerWinModal').fadeOut();
            })

            /********************Document Ready***********************/
            $(document).ready(function () {

                /*test*/
                getWallet();
                /*end of test*/

                if (window.location.href.startsWith("https://s.folkspel.se/b/")) {
                    var correctedURL = "https://www.bingolotto.se/ratta-lotten/";
                    var seriesAndTicketNumber = window.location.href.slice(window.location.href.indexOf('/b/') + 3);
                    var series = seriesAndTicketNumber.substring(0, 4);
                    var ticket = seriesAndTicketNumber.slice(4);

                    correctedURL = correctedURL + "?s=" + series + "&l=" + ticket;

                    window.location.replace(correctedURL);
                }

                //Code for detecting mobile browser
                (function (a) { (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)) })(navigator.userAgent || navigator.vendor || window.opera);

                manuallyTicketStoredInSession = window.fsStorage.get('redeem.manual.ticket_list');

                if (!$.browser.mobile) {
                    resetPanels();
                    showManualStep();
                } else {
                    //Render stored stickets
                    ticketStoredInSession = window.fsStorage.get('redeem.ticket_list');

                    if (!ticketStoredInSession) {
                        ticketStoredInSession = [];
                    } else {
                        for (var i = 0; i < ticketStoredInSession.length; i++) {
                            if (ticketStoredInSession[i].Winnings == null || !ticketStoredInSession[i].Winnings.length) {
                                ticketStoredInSession[i].Winnings = null;
                            }

                            var isHighWin = false;
                            if (ticketStoredInSession[i].Succeeded == false && ticketStoredInSession[i].ErrorCode == 7002) {
                                isHighWin = true;
                            }
                            addScannedTicketsToList(createIconUrl(ticketStoredInSession[i].ProductNumber, ticketStoredInSession[i].ArticleNumber), ticketStoredInSession[i].ProductNumber, ticketStoredInSession[i].ProductName, ticketStoredInSession[i].Winnings, isHighWin);
                        }

                        resetPanels();
                        showStep2();
                    }
                }
                //End of browser detection code

       /*         manuallyTicketStoredInSession = window.fsStorage.get('redeem.manual.ticket_list');*/

                var counter = 0;
                $('h1', '.ticketCashInStep1').click(function () {
                    counter++;
                    if (counter > 10) {
                        counter = 0;
                        resetPanels();
                        showStep2();
                    }
                });

                if (!manuallyTicketStoredInSession) {
                    manuallyTicketStoredInSession = [];
                } else {
                    for (var i = 0; i < manuallyTicketStoredInSession.length; i++) {
                        if (manuallyTicketStoredInSession[i].Winnings == null || !manuallyTicketStoredInSession[i].Winnings.length) {
                            manuallyTicketStoredInSession[i].Winnings = null;
                        } 
                        addManualTicketsToList(manuallyTicketStoredInSession[i].Winnings, manuallyTicketStoredInSession[i].Series + " " + manuallyTicketStoredInSession[i].Number, manuallyTicketStoredInSession[i].Multiplier);
                    }
                    scrollToManualList();
                }


                //Cancels the current scanning session and returns to step 2.
                $('#cancelScannerButton').click(function () {
                    scanningEnabled = false;

                    pauseScanning().then(() => {
                        console.log("Async function completed successfully");

                    }).catch((error) => {
                        console.log("Async function encountered an error: ", error);
                        console.log(error);
                    });

                    Utils.PushGoogleTag('Click_close_scanner_button');

                    resetPanels();
                    showStep2();
                });

                $("#scanTicketButton").click(function () {
                    Utils.PushGoogleTag('Click_start_scanning_button');

                    scanningEnabled = true;

                    if ($("#reader .scandit-container").length == 0) {
                        scanTicket().then(() => {
                            console.log("Async function completed successfully");

                        }).catch((error) => {
                            console.log("Async function encountered an error: ", error);
                            console.log(error);
                            // Start failed, handle it.
                            //Browser instructions
                            var allowCameraDescription = "Vi kunde inte hitta din kamera. Tryck på *bold_start*skanna en lott*bold_end* igen och *bold_start*välj tillåt*bold_end* när alternativen visas. Fick du ingen fråga? Kontrollera att din webbläsare har tillåtelse att använda kameran.";
                            if ($("body").data("nativeapp") == "BingoLottoAndroid") {
                                //Android instructions
                                allowCameraDescription = "Vi kunde inte hitta din kamera. Kontrollera att BingoLotto har tillstånd att använda den.*new_line**new_line*Öppna *bold_start*Inställningar*bold_end* på din enhet.*new_line*Bläddra ner till *bold_start*\"Appar\" eller \"Program\"*bold_end* och tryck på den.*new_line*Hitta *bold_start*BingoLotto*bold_end* appen och tryck på den.*new_line*Klicka på *bold_start*\"Behörigheter\" eller \"Tillstånd\"*bold_end* under appens inställningar.*new_line**bold_start*Välj \"Kamera\"*bold_end* och tryck på omkopplaren bredvid för att ge appen tillgång till din kamera.*new_line*Öppna sedan BingoLottos app och skanna igen, *bold_start*välj \"Tillåt\"*bold_end* om appen ber om tillstånd att använda kameran.";
                            } else if ($("body").data("nativeapp") == "BingoLottoiPhone") {
                                //iOS instructions
                                allowCameraDescription = "Vi kunde inte hitta din kamera. Kontrollera att BingoLotto har tillstånd att använda den.*new_line**new_line*Öppna *bold_start*Inställningar*bold_end* på din enhet.*new_line*Bläddra ner till appen *bold_start*BingoLotto*bold_end* och tryck på den.*new_line*Klicka på \"*bold_start*Kamera*bold_end*\" under appens inställningar.*new_line**bold_start*Välj \"Tillåt\"*bold_end* för att ge appen tillgång till din kamera.*new_line*Öppna sedan BingoLottos app och skanna igen och *bold_start*välj \"Tillåt\"*bold_end* om appen ber om tillstånd att använda kameran.";
                            }
                            ModalHandler.InformationModal("KAN INTE HITTA KAMERA", "fas fa-solid fa-camera fa-4x purpleIcon", allowCameraDescription, function () {
                                resetPanels();
                                showStep2();
                            });
                        });
                    } else {
                        continueScanning();
                    }
                    
                });

                var barcodeCaptureOverlay;
                var barcodeCapture;
                var viewfinder;
                var camera;

                async function continueScanning() {
                    //await barcodeCaptureOverlay.setViewfinder(viewfinder);
                    // Switch the camera on to start streaming frames.
                    // The camera is started asynchronously and will take some time to completely turn on.
/*                    await camera.switchToDesiredState(SDCCore.FrameSourceState.On);*/
                    await barcodeCapture.context.frameSource.switchToDesiredState(SDCCore.FrameSourceState.On);
                    await barcodeCapture.setEnabled(true);
                }

                async function pauseScanning() {
                    //await barcodeCaptureOverlay.setViewfinder(viewfinder);
                    // Switch the camera on to start streaming frames.
                    // The camera is started asynchronously and will take some time to completely turn on.
                  /*  await camera.switchToDesiredState(SDCCore.FrameSourceState.Standby);*/
                    await barcodeCapture.context.frameSource.switchToDesiredState(SDCCore.FrameSourceState.Off);
                    await barcodeCapture.setEnabled(false);
                }

                async function scanTicket() {

                   // var libraryUrl = new URL("Static/js/", "https://" + window.location.hostname + "/").toString();
                   // if (window.location.hostname.includes("localhost")) {
                   ///*     libraryUrl = new URL("Static/js/", "http://localhost:53983/").toString();*/
                   //    /* libraryUrl = new URL("scandit/", "https://test-cdn.folkspel.se").toString();*/ //TODO- lägg till sitestting
                   //     /*libraryUrl = new URL("scandit/", $widget.options.cdn_url).toString(); */

                   // }

                    var libraryUrl = new URL("scandit/", $widget.options.cdn_url).toString(); 

                    await SDCCore.configure({
                        licenseKey: $widget.options.api_key,
                        // For local testing:
                        
                        libraryLocation: libraryUrl,
                        moduleLoaders: [SDCBarcode.barcodeCaptureLoader({ highEndBlurryRecognition: false })],
                    });

                    // Create the data capture context.
                    const context = await SDCCore.DataCaptureContext.create();

                    // Try to use the world-facing (back) camera and set it as the frame source of the context. The camera is off by
                    // default and must be turned on to start streaming frames to the data capture context for recognition.
                    camera = SDCCore.Camera.default;
                    const cameraSettings = SDCBarcode.BarcodeCapture.recommendedCameraSettings;
                    await camera.applySettings(cameraSettings);
                    await context.setFrameSource(camera);

                    // The barcode capturing process is configured through barcode capture settings,
                    // they are then applied to the barcode capture instance that manages barcode recognition.
                    const settings = new SDCBarcode.BarcodeCaptureSettings();

                    //When the filter is set to - 1, each unique code is only added once to the session,
                    //when set to 0, duplicate filtering is disabled.Otherwise the duplicate filter
                    //specifies an interval in milliseconds.
                    settings.codeDuplicateFilter = 5000;

                    // The settings instance initially has all types of barcodes (symbologies) disabled. For the purpose of this
                    // sample we enable a very generous set of symbologies. In your own app ensure that you only enable the
                    // symbologies that your app requires as every additional enabled symbology has an impact on processing times.
                    settings.enableSymbologies([
                        SDCBarcode.Symbology.DataMatrix
                    ]);

                    // Some linear/1D barcode symbologies allow you to encode variable-length data. By default, the Scandit
                    // Data Capture SDK only scans barcodes in a certain length range. If your application requires scanning of one
                    // of these symbologies, and the length is falling outside the default range, you may need to adjust the "active
                    // symbol counts" for this symbology. This is shown in the following few lines of code for one of the
                    // variable-length symbologies.
                    const symbologySettings = settings.settingsForSymbology(SDCBarcode.Symbology.Code39);
                    symbologySettings.activeSymbolCounts = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

                    // Create a new barcode capture mode with the settings from above.
                    barcodeCapture = await SDCBarcode.BarcodeCapture.forContext(context, settings);
                    // Disable the barcode capture mode until the camera is accessed.
                    await barcodeCapture.setEnabled(false);

                    // Register a listener to get informed whenever a new barcode got recognized.
                    barcodeCapture.addListener({
                        didScan: async function (barcodeCapture, session) {
                    /*        await camera.switchToDesiredState(SDCCore.FrameSourceState.Standby);*/

                            const barcode = session.newlyRecognizedBarcodes[0];
                            const symbology = new SDCBarcode.SymbologyDescription(barcode.symbology);

                            // no more didScan callbacks will be invoked after this call.
                            await barcodeCapture.setEnabled(false);
                            // asynchronously turn off the camera as quickly as possible.
                            await barcodeCapture.context.frameSource.switchToDesiredState(SDCCore.FrameSourceState.Off);

                            Utils.LogDataMatrixScan(barcode.data);

                            showResult(barcode.data);
                        }
                    });

                    // To visualize the ongoing barcode capturing process on screen, set up a data capture view that renders the
                    // camera preview. The view must be connected to the data capture context.
                    const view = await SDCCore.DataCaptureView.forContext(context);

                    // Connect the data capture view to the HTML element.
                    view.connectToElement($("#reader")[0]);

                    // Add a control to be able to switch cameras.
                    //view.addControl(new SDCCore.CameraSwitchControl());

                    // Add a barcode capture overlay to the data capture view to render the location of captured barcodes on top of
                    // the video preview. This is optional, but recommended for better visual feedback.
                    barcodeCaptureOverlay =
                        await SDCBarcode.BarcodeCaptureOverlay.withBarcodeCaptureForViewWithStyle(
                            barcodeCapture,
                            view,
                            SDCBarcode.BarcodeCaptureOverlayStyle.Frame
                        );
                    viewfinder = new SDCCore.RectangularViewfinder(
                        SDCCore.RectangularViewfinderStyle.Square,
                        SDCCore.RectangularViewfinderLineStyle.Light
                    );
                    await barcodeCaptureOverlay.setViewfinder(viewfinder);

                    // Switch the camera on to start streaming frames.
                    // The camera is started asynchronously and will take some time to completely turn on.
/*                    barcodeCapture.context.frameSource.switchToDesiredState(SDCCore.FrameSourceState.Off)*/
                    /*camera.switchToDesiredState(SDCCore.FrameSourceState.On).then(() => {*/
                    barcodeCapture.context.frameSource.switchToDesiredState(SDCCore.FrameSourceState.On).then(() => {
                            console.log("Camera on");

                    }).catch((error) => {
                        $('#reader').empty();
                        camera = null;
                        barcodeCapture = null;
                        barcodeCaptureOverlay = null;
                        viewfinder = null;
                        context.dispose();

                        console.log("Camera error: ", error);
                        console.log(error);
                        // Start failed, handle it.
                        //Browser instructions
                        var allowCameraDescription = "Vi kunde inte hitta din kamera. Tryck på *bold_start*skanna en lott*bold_end* igen och *bold_start*välj tillåt*bold_end* när alternativen visas. Fick du ingen fråga? Kontrollera att din webbläsare har tillåtelse att använda kameran.";
                        if ($("body").data("nativeapp") == "BingoLottoAndroid") {
                            //Android instructions
                            allowCameraDescription = "Vi kunde inte hitta din kamera. Kontrollera att BingoLotto har tillstånd att använda den.*new_line**new_line*Öppna *bold_start*Inställningar*bold_end* på din enhet.*new_line*Bläddra ner till *bold_start*\"Appar\" eller \"Program\"*bold_end* och tryck på den.*new_line*Hitta *bold_start*BingoLotto*bold_end* appen och tryck på den.*new_line*Klicka på *bold_start*\"Behörigheter\" eller \"Tillstånd\"*bold_end* under appens inställningar.*new_line**bold_start*Välj \"Kamera\"*bold_end* och tryck på omkopplaren bredvid för att ge appen tillgång till din kamera.*new_line*Öppna sedan BingoLottos app och skanna igen, *bold_start*välj \"Tillåt\"*bold_end* om appen ber om tillstånd att använda kameran.";
                        } else if ($("body").data("nativeapp") == "BingoLottoiPhone") {
                            //iOS instructions
                            allowCameraDescription = "Vi kunde inte hitta din kamera. Kontrollera att BingoLotto har tillstånd att använda den.*new_line**new_line*Öppna *bold_start*Inställningar*bold_end* på din enhet.*new_line*Bläddra ner till appen *bold_start*BingoLotto*bold_end* och tryck på den.*new_line*Klicka på \"*bold_start*Kamera*bold_end*\" under appens inställningar.*new_line**bold_start*Välj \"Tillåt\"*bold_end* för att ge appen tillgång till din kamera.*new_line*Öppna sedan BingoLottos app och skanna igen, *bold_start*välj \"Tillåt\"*bold_end* om appen ber om tillstånd att använda kameran.";
                        }
                        ModalHandler.InformationModal("KAN INTE HITTA KAMERA", "fas fa-solid fa-camera fa-4x purpleIcon", allowCameraDescription, function () {
                            resetPanels();
                            showStep2();
                        });
                    });


                    await barcodeCapture.setEnabled(true);

                    await barcodeCapture.context.frameSource.switchToDesiredState(SDCCore.FrameSourceState.On);

                    function showResult(result) {
                        if (scanningEnabled) {
                            $('#scanTicketLoading-overlay').show();
                            $('.ticketCashInStep3').hide();
                            if (!Utils.UserIsLoggedIn()) {
                                window.fsStorage.set('redeem.ticketqr', result, 60 * 5);
                                Utils.Authenticate();
                                return;
                            }
                            if (Utils.UserIsLoggedIn()) {
                                handleScannedQrCode(result);
                            }
                        }
                        scanningEnabled = false;
                    }

                    window.continueScanning = async function () {
                        $(".result").remove();
                        await barcodeCapture.setEnabled(true);
                        // Restore the viewfinder.
                        await barcodeCaptureOverlay.setViewfinder(viewfinder);
                    };
                }

                var handleScannedQrCode = function (decodedText) {
                    $('#scanTicketLoading-overlay').show();
                    $.ajax({
                        url: '/Ticket/RedeemPhysicalTicket',
                        type: "POST",
                        dataType: "json",
                        data: { PayLoad: decodedText },
                        success: function (response) {
                            console.log(response);

                            //***Custom HTML tags for modal strings***
                            //*new_line* == <br>
                            //*bold_start* <b>
                            //*bold_end* </b>
                            //KOD FÖR OM DET ÄR FLERA VINSTER PÅ LOTTEN
                            articleNumber = response.ArticleNumber;
                            productArticleMap = response.ArticleProductMap;
                            mappedProductNumber = productArticleMap[mappedProductNumber];

                            bingoBonus = response.BingoBonus;

                            response.Piid = decodedText;
                            //Nitlott
                            if (response.Succeeded == true && response.Winnings.length <= 0) {
                                var displayAccount = "Svenskt föreningsliv";
                                var shortMessage = " tackar dig för ditt stöd!";

                                getTicketAccount(response?.SellerAccount);

                                if (sellerAccountType !== "Association" || sellerAccountType !== "Team") {
                                    sellerAccountName = displayAccount;
                                }

                                $('#scanTicketLoading-overlay').hide();
                                ModalHandler.InformationModal("INGEN VINST", "fas fa-solid fa-heart fa-4x redIcon", "Det blev tyvärr ingen vinst den här gången. *new_line**new_line**bold_start*" + sellerAccountName + "*bold_end*" + shortMessage, function () { });
                                addScannedTicketsToList(createIconUrl(response.ProductNumber, response.ArticleNumber), response.ProductNumber, response.ProductName, null, false);

                                resetPanels();
                                showStep2(true);
                            }
                            //Felmeddelande
                            else if (response.Succeeded == false && response.ErrorCode != 7002) {
                                $('#scanTicketLoading-overlay').hide();
                                ModalHandler.InformationModal("ETT FEL INTRÄFFADE", "", response.Message, function () { });
                                resetPanels();
                                showStep2();
                            }
                            //Vinst
                            else {
                                $('#winList').empty();
                                //Högvinst
                                if (response.Succeeded == false && response.ErrorCode == 7002) {

                                    //Check if highwin has already been scanned
                                    if (ticketStoredInSession.length) {
                                        for (var i = 0; i < ticketStoredInSession.length; i++) {
                                            if (ticketStoredInSession[i].Piid == response.Piid) {
                                                ModalHandler.InformationModal("GRATTIS!",
                                                    "fas fa-solid fa-exclamation fa-4x purpleIcon",
                                                    "Du har vunnit en högvinst! *bold_start*Vad gör jag nu? *bold_end* *new_line* Skicka in lotten rekommenderat till: *new_line* *new_line* *bold_start* BingoLotto *new_line* Box 5 *new_line* 433 21 Partille", function () { });
                                                $('#scanTicketLoading-overlay').hide();
                                                resetPanels();
                                                showStep2(true);
                                                return;
                                            }
                                        }
                                    } 

                                    $.each(response.Winnings, function (key, val) {
                                        if (val.IsHighWin) {
                                            var winAmount = val.Amount;
                                            var winDescription = val.Description;
                                            var displayWinAmount = val.DisplayAmount;
                                            var modalWinSummary = winDescription.replace("&", "och"); //Clean the text of strange characters
                                            let formattedWinAmount = winAmount.toLocaleString('en-US', { useGrouping: false }).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
                                            if (displayWinAmount == true) {
                                                modalWinSummary = modalWinSummary + " till ett värde av " + formattedWinAmount + " kronor";
                                            }

                                            let highWinMultiplierInfoText = "";
                                            if (response.ProductNumber == BingolottoProductNumber) {
                                                highWinMultiplierInfoText = "*new_line**new_line* Har du en dubbellott? X2 ger 2 gånger vinsten, X3 ger 3 gånger vinsten.";
                                            }

                                            //Visa modal
                                            setTimeout(function () {
                                                $('.ticketCheckerWinModal').fadeOut();
                                                ModalHandler.InformationModal("GRATTIS!",
                                                    "fas fa-solid fa-exclamation fa-4x purpleIcon",
                                                    "Du har vunnit en högvinst! *bold_start*" + modalWinSummary + "! *new_line* *new_line* Vad gör jag nu? *bold_end* *new_line* Skicka in lotten rekommenderat till: *new_line* *new_line* *bold_start* BingoLotto *new_line* Box 5 *new_line* 433 21 Partille*bold_end*" + highWinMultiplierInfoText, function () { });
                                            }, 4000)
                                        }
                                    });
                                    //VISA VINSTSPLASH
                                    $('#winList').append('<div class="winningsDisplayer">HÖGVINST!</div>');
                                    $('#scanTicketLoading-overlay').hide();
                                    $('.ticketCheckerWinModal').show();
                                    confettiCannon();
                                    addScannedTicketsToList(createIconUrl(response.ProductNumber, response.ArticleNumber), response.ProductNumber, response.ProductName, response.Winnings, true);
                                    resetPanels();
                                    showStep2(true);

                                } else {
                                    //Vanlig vinst
                                    //Lägg till vinst på vinstSplash. (Kan vara flera vinster)
                                    lastScannedArticleNumber = response.ArticleNumber;
                                    lastScannedProductNumber = response.ProductNumber;
                                    handleLowWin(0, response.Winnings);

                                    
                                    $.each(response.Winnings, function (key, val) {
                                        var winAmount = val.Amount;
                                        var winDescription = val.Description;
                                        var winMultiplier = val.Multiplier;
                                        var displayWinAmount = val.DisplayAmount;

                                        var totalWinAmount = winAmount * winMultiplier;
                                        var modalWinSummary = winDescription;
                                        var modalWinnings = totalWinAmount + " kronor";

                                        if (displayWinAmount == true) {
                                            modalWinSummary = modalWinSummary + " till ett värde av " + totalWinAmount + " kronor.";
                                        }
                                        if (displayWinAmount == false || val.IsTicketWin) {
                                            modalWinnings = winDescription;
                                        }

                                        $('#winList').append('<div class="winningsDisplayer">' + modalWinnings + '</div>');
                                    });
                                    

                                    //VinstSplash
                                    $('#scanTicketLoading-overlay').hide();
                                    $('.ticketCheckerWinModal').show();
                                    confettiCannon();

                                    addScannedTicketsToList(createIconUrl(response.ProductNumber, response.ArticleNumber), response.ProductNumber, response.ProductName, response.Winnings, false);
                                    resetPanels();
                                    showStep2(true);

                                }
                                //End of vinstlott
                            }

                            //If win/nit/highwin add to sessionstorage.
                            if (response.Succeeded == true || (response.Succeeded == false && response.ErrorCode == 7002)) {
                                ticketStoredInSession.push(response);
                                window.fsStorage.set('redeem.ticket_list', ticketStoredInSession, 60 * 30);
                            }

                        },
                        error: function (response) {
                            //Fix error codes
                            console.log("error " + response);

                        }
                    });
                }

                userCommissions = getUserCommissions();

                function initialize() {
                    var serieNumber = Utils.GetUrlParamByName("s");
                    var ticketNumber = Utils.GetUrlParamByName("l"); 
                    var ticketPiid = Utils.GetUrlParamByName("p");
                    var decodedText = window.fsStorage.get('redeem.ticketqr');
                    var tempPiid = window.fsStorage.get('temppiid');


                    if (decodedText) {
                        window.fsStorage.removeItem('redeem.ticketqr');
                        if (Utils.UserIsLoggedIn()) {
                            resetPanels();
                            showStep2();

                            handleScannedQrCode(decodedText);
                        }
                    } else if (tempPiid) {
                        window.fsStorage.removeItem('temppiid');
                        resetPanels();
                        showManualStep();
                        $('#manualInputField', $this).val(tempPiid);
                        manualCheckTicket();
                    } else if (serieNumber != "" && ticketNumber != "") {
                        window.fsStorage.set('temppiid', serieNumber + ticketNumber, 60 * 1);
                        window.location.replace(window.location.href.split('?')[0]);
                    } else if (ticketPiid !== "") {
                        window.fsStorage.set('temppiid', ticketPiid, 60 * 1);
                        window.location.replace(window.location.href.split('?')[0]);
                    }
                }

                initialize();

                window.fsEvents.on('tickets.purchase.success', (event) => {
                    //Hitta den rad som success tillhör, bör vara den första som jquery upptäcker.
                    $(".winningActionDiv").eq(0).html(`<a href="/mina-sidor/?page=/MyPages/Tickets" class="btn btn btn-primary" target="_self">Mina lotter</a>`)
                });
            });
            //****************End of document ready.****************


            //Code for confetticannon
            //call confettiCannon() to shoot confetti!!!
            var confettiCannon = function () {
                const colors = [
                    "#6B2F87",
                    "#BE97C5",
                    "#DDC0DD",
                    "#EF7D17",
                    "#FDC530",
                    "#FBD391",
                    "#B3DED6",
                    "#81C8BA",
                    "#ED6EA7",
                    "#F4A8CA"
                ];

                const shootConfetti = () => {
                    confetti({
                        particleCount: 200,
                        spread: 360,
                        ticks: 120,
                        startVelocity: 35,
                        origin: { x: 0.5, y: 0.40 },
                        shapes: ["circle"],
                        zIndex: 500000000000,
                        scalar: 0.5,
                        colors
                    });
                    confetti({
                        particleCount: 600,
                        spread: 360,
                        ticks: 120,
                        startVelocity: 50,
                        origin: { x: 0.5, y: 0.40 },
                        shapes: ["circle"],
                        zIndex: 500000000000,
                        colors
                    });
                };


                shootConfetti();
            }

            //Retrieves a purchase suggestion when a ticket contains a win.
            function sendPurchaseSuggestion(articleNumber, amount, maxQuantity) {
                $.ajax({
                    url: '/Ticket/PurchaseSuggestion',
                    type: "POST",
                    dataType: "json",
                    data: {
                        ArticleNumber: articleNumber,
                        Amount: amount,
                        MaxSuggestedQuantity: maxQuantity
                    },
                    success: function (response) {
                        console.log(response);
                        availableTicketAmount = response.Quantity;
                        suggestionProductName = response.ProductName;
                        suggestionGameStart = response.GameStart;
                        suggestionArticleNumber = response.ArticleNumber;
                        suggestionProductNumber = response.ProductNumber;
                        suggestionArticleKey = response.RoundArticleKey;
                        suggestionArticlePrice = response.Price;
                    },
                    error: function (response) {
                        console.log(response);
                    }
                });
            }

            //Get Account/Reseller
            function getTicketAccount(sellerAccount) {
                if (sellerAccount) {
                    $.ajax({
                        url: '/common2/getaccount',
                        type: "POST",
                        dataType: "json",
                        data: {
                            payLoad: sellerAccount
                        },
                        success: function (response) {
                            console.log(response);
                            sellerAccountType = response.AccountType;
                            sellerAccountName = response.Name;
                            sellerAccountActive = response.Active;
                        },
                        error: function (response) {
                            console.log(response);
                        }
                    });
                }
            }


            //Get Wallet
            function getWallet() {
                $.ajax({
                    url: window.Urls.GetWallet,
                    type: 'GET',
                    dataType: "json",
                    success: function (response) {

                        if (response.bonuses && Array.isArray(response.bonuses)) {
                            response.bonuses.forEach(function (bonus) {
                                if (bonus.systemId === 1) {
                                    bingoBonusAmount = bonus.amount;
                                }
                            });

                            updateHtmlWithBonusAmount(bingoBonusAmount);
                        }
                    },
                    error: function (textStatus, errorThrown) {
                        console.error('Error fetching wallet:', textStatus, errorThrown);
                    }
                });
            }

            function updateHtmlWithBonusAmount(bingoBonusAmount) {
                if (bingoBonusAmount > 0) {
                    $('#bonusAmountText').text(bingoBonusAmount + ' kr');
                    $('.bingoBonusDiv').show();
                } else {
                    $('.bingoBonusDiv').hide();
                }
            }

            //Get 
            function getUserCommissions() {
                $.ajax({
                    url: Urls.GetCommissionInfo,
                    type: "POST",
                    dataType: "json",
                    success: function (response) {
                        console.log(response);
                        userCommissions = response.Items;
                    },
                    error: function (response) {
                        console.log(response);
                    }
                });
            }

            var createCommissionPayLoad = function (userCommissions) {
                var commission = {
                    preset: [],
                    userPreset: [],
                    getUserCommisionIfEmptyPreset: true
                };
                $.each(userCommissions, function (index, userCommission) {
                        commission.userPreset.push({
                            id: userCommission.CommissionAccountId,
                            title: userCommission.CommissionAccountName
                        });
                });
                return commission;
            };

            //
            function performPurchaseTicket(articleToBuy, quantityToBuy) {
                window.fsTickets.purchase({
                    purchases: [
                        {
                            roundArticle: articleToBuy,
                            quantity: quantityToBuy
                        }],
                    commission: createCommissionPayLoad(userCommissions),
                    success: { action: 'close' }
                });
            }

            function handleLowWin(index, winningsList) {

                var val = winningsList[index]; 
                index++;

                var hasMoreWinnings = false;
                if (winningsList.length >= index + 1) {
                    hasMoreWinnings = true;
                } else {
                    winIndex = 0;
                    globalWinningsList = "";
                }

                

                var winAmount = val.Amount;
                var winDescription = val.Description;
                var winMultiplier = val.Multiplier;
                var displayWinAmount = val.DisplayAmount;
                var maxSuggestedTicketQuantity = 2;

                var isCashWin = val.IsCashWin;
                var isTicketWin = val.IsTicketWin;
                var ticketToSuggest = val.TicketWinArticle;

                var totalWinAmount = winAmount * winMultiplier;
                var modalWinSummary = winDescription;
                var modalWinnings = totalWinAmount + " kronor";

                if (displayWinAmount == true) {
                    modalWinSummary = modalWinSummary + " till ett värde av " + totalWinAmount + " kronor.";
                }
                if (displayWinAmount == false) {
                    modalWinnings = winDescription;
                }
                if (isTicketWin) {
                    maxSuggestedTicketQuantity = 10;
                }
                //Get purchase suggestion depending on winning amount and article.
                if (ticketToSuggest == "" || ticketToSuggest == null) {
                    ticketToSuggest = lastScannedArticleNumber;
                }
                //Om ticketWinArticle är tom --> Ta ArticleNumber
                sendPurchaseSuggestion(ticketToSuggest, totalWinAmount, maxSuggestedTicketQuantity);

                setTimeout(function () {
                    $('.ticketCheckerWinModal').fadeOut();
                    if (isCashWin) {
                        if (availableTicketAmount >= 1) {
                            var confirmButtonText = "Jag vill ha en ny lott";
                            if (availableTicketAmount > 1) {
                                confirmButtonText = "Jag vill ha nya lotter";
                            }
                            var bingoTicketInfo = "";
                            if (suggestionProductNumber == BingolottoProductNumber) {
                                var slicedDate = suggestionGameStart.slice(0, 10);
                                bingoTicketInfo = "*new_line* Köpet gäller för nästa program " + slicedDate;
                            }
                            ModalHandler.PurchaseSuggestionModal("GRATTIS!", "*bold_start* Du har vunnit " + totalWinAmount + " kronor. *bold_end* *new_line* För det kan du köpa:", suggestionProductName, totalWinAmount, availableTicketAmount, bingoTicketInfo, confirmButtonText, "SÄTT IN PENGARNA PÅ MITT FOLKSPELSKONTO", lastScannedProductNumber, lastScannedArticleNumber, function (result) {
                                if (result) {
                                    //yes 
                                    $('#siteModal').modal('hide');

                                    if (hasMoreWinnings) {
                                        //spara winningslist & index så att fsevents.success kan fortsätta iterera vinster.
                                        winIndex = index;
                                        globalWinningsList = winningsList;
                                    }
                                    performPurchaseTicket(suggestionArticleKey, availableTicketAmount);
                                    return;
                                } else {
                                    //no
                                    //Close modal 
                                    $('#siteModal').modal('hide');

                                    //check if the ticket has more than one win
                                    if (hasMoreWinnings) {
                                        handleLowWin(index, winningsList);
                                    }
                                }
                            });
                        }
                        else {
                            ModalHandler.InformationModal("GRATTIS!", "", "Du har *bold_start* vunnit " + totalWinAmount + " kronor. *bold_end* *new_line* Vi har satt in pengarna på ditt Folkspelskonto.", function (result) {
                                if (hasMoreWinnings) {
                                    handleLowWin(index, winningsList);
                                }
                            });
                        }
                    }
                    if (isTicketWin) {
                        if (availableTicketAmount >= 1) {
                            var confirmButtonText = "Jag vill ha en ny lott";
                            var bingoTicketInfo = "";
                            if (availableTicketAmount > 1) {
                                confirmButtonText = "Jag vill ha nya lotter";
                            }
                            if (suggestionProductNumber == BingolottoProductNumber) {
                                var slicedDate = suggestionGameStart.slice(0, 10);
                                bingoTicketInfo = "*new_line* Vill du ta ut din vinst direkt gäller lotten för nästa program " + slicedDate;
                            }
                            ModalHandler.PurchaseSuggestionModal("GRATTIS", "*bold_start* Du har vunnit: *bold_end* *new_line*" + modalWinSummary + "*new_line* *new_line* Du kan välja att ta ut din vinstlott direkt, eller sätta in summan som bonus på ditt Folkspelskonto. *new_line*" + bingoTicketInfo, "", "", "", "", confirmButtonText, "SÄTT IN PÅ MITT FOLKSPELSKONTO", "", "", function (result) {
                                if (result) {
                                    //yes 
                                    $('#siteModal').modal('hide');
                                    if (hasMoreWinnings) {
                                        //spara winningslist & index så att fsevents.success kan fortsätta iterera vinster.
                                        winIndex = index;
                                        globalWinningsList = winningsList;
                                    }
                                    performPurchaseTicket(suggestionArticleKey, availableTicketAmount);
                                    return;
                                } else {
                                    //no
                                    //Close modal 
                                    $('#siteModal').modal('hide');
                                    //check if the ticket has more than one win
                                    if (winningsList.length >= index + 1) {
                                        handleLowWin(index, winningsList);
                                    }
                                }
                            });
                        }
                        else {
                            ModalHandler.InformationModal("GRATTIS!", "", "Du har *bold_start* vunnit " + totalWinAmount + " kronor att köpa bingolotter *bold_end* för. *new_line* Vi har satt in summan som bonus. Din bonus dras automatiskt nästa gång du köper en bingolott på vår hemsida.", function (result) {
                                if (hasMoreWinnings) {
                                    handleLowWin(index, winningsList);
                                }
                            });
                        }
                    }

                }, 4000);
            }
        }
    });







